import platform from './platform';
import product from './product';
import hosts from './hosts';
import accounts from './accounts';
import kinesis from './kinesis';
import permissions from './permissions';
import rum from './cloudwatch-rum';
import {stage} from './stage';

// Top-level config aggregate. Every question about "what is this app
// called / where does it live / which accounts does it talk to" is
// answered in one of the modules below, and answered ONCE.
export const config = {
    stage,
    product,
    platform,
    hosts,
    accounts,
    kinesis,
    permissions,
    rum,
    // Display strings read from product.ts — never type the app's name
    // into a component (FNP-1367).
    appTitle: product.displayName,
    appSubTitle: product.description,
};

export default config;
